import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Colors } from '../../themes/colors';
import { Button, ButtonProps } from '../crop-circle/Button';
import { ResetIcon } from '../crop-circle/icons';
import { tokens } from '../crop-circle/tokens';

type RestartButtonProps = ButtonProps & {
  disabled?: boolean;
};

const getIconColor = (
  state: ButtonProps['state'],
  disabled: boolean
): string => {
  if (disabled) {
    return tokens.colors.neutral[300];
  }

  switch (state) {
    case 'active':
    case 'warning':
      return Colors.role.textOnBrand;
    case 'outline':
      return tokens.colors.orange[600];
    case 'default':
    default:
      return tokens.colors.system.textPrimary;
  }
};

export const RestartButton: FC<RestartButtonProps> = ({
  style,
  state: stateProp,
  disabled: disabledProp,
  accessibilityLabel,
  children,
  ...rest
}: RestartButtonProps) => {
  const { t } = useTranslation();
  const state = stateProp ?? 'active';
  const disabled = disabledProp ?? false;
  const iconColor = getIconColor(state, disabled);

  return (
    <Button
      {...rest}
      style={StyleSheet.flatten([styles.container, style])}
      state={state}
      disabled={disabled}
      leftIcon={<ResetIcon color={iconColor} size={24} />}
      accessibilityLabel={accessibilityLabel ?? t('common.reset')}
    >
      {children}
    </Button>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 56,
    height: 56,
    minWidth: 56,
    maxHeight: 56,
    borderRadius: 99,
    marginRight: 16,
  },
});
